/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約者情報
 */
export interface Sgkb575aResCtrperInfo {
    /** 
     * 契約者需要者区分：半角英数混在
     */
    ctrperCnsdiv?: string;
    /** 
     * 契約者需要者区分名称：全角半角混在
     */
    ctrperCnsdivAname?: string;
    /** 
     * 契約者お客さま漢字氏名：全角文字
     */
    ctrperName?: string;
    /** 
     * 契約者お客さまカナ氏名：全角カナ
     */
    ctrperKanaName?: string;
    /** 
     * 契約者お客さま電話番号コード１：半角英数混在
     */
    ctrperTeldv1?: string;
    /** 
     * 契約者お客さま電話番号コード１名称：全角半角混在
     */
    ctrperTeldv1Aname?: string;
    /** 
     * 契約者お客さま電話番号１：電話番号(ハイフンと数値含む)
     */
    ctrperTelNo1?: string;
    /** 
     * 契約者お客さま電話番号コード２：半角英数混在
     */
    ctrperTeldv2?: string;
    /** 
     * 契約者お客さま電話番号コード２名称：全角半角混在
     */
    ctrperTeldv2Aname?: string;
    /** 
     * 契約者お客さま電話番号２：電話番号(ハイフンと数値含む)
     */
    ctrperTelNo2?: string;
    /** 
     * 契約者お客さま電話番号コード３：半角英数混在
     */
    ctrperTeldv3?: string;
    /** 
     * 契約者お客さま電話番号コード３名称：全角半角混在
     */
    ctrperTeldv3Aname?: string;
    /** 
     * 契約者お客さま電話番号３：電話番号(ハイフンと数値含む)
     */
    ctrperTelNo3?: string;
    /** 
     * 契約者住所更新有無フラグ：半角英数混在
     */
    ctrperAddrUpdateumuflag?: string;
    /** 
     * 契約者住所更新有無フラグ名称：全角半角混在
     */
    ctrperAddrUpdateumuflagAname?: string;
    /** 
     * 契約者住所番地・号・分筆号：全角文字
     */
    contractpersonaddressBlockgoulot?: string;
    /** 
     * 契約者住所番地・号・分筆号（カナ）：全角英数カナ
     */
    ctrperAddrBlockgoulotkana?: string;
}
